import env from 'enviro';
import { CHECKOUT_INTERSTITIAL_UI_GATE, FTS_STAGED_USERS, HUBSPOT_CREDITS, PURCHASE_MOTION_CTA, RECOMMENDED_VIEW, REMOVE_MERCH_CARD_STEPPERS_GATE } from '../constants/Gates';
import { HUBSPOT_CREDITS_FLAG, SEATS_VERSIONS_FEATURE_FLAG } from '../constants/PublicFeatureFlags';
import { SEATS_ACCESS } from '../constants/Scopes';
import { hasAnyMarketingPlusSkuInProductData, hasBreezeIntelligenceSkusInProductData, hasHubSpotCreditsSkuInProductData } from './productsUtils';
import { getIsQAProxy } from './proxyUtils';
import safeLocalStorage from './safeLocalStorage';
export const getIsUngated = (state, {
  gateKey
}) => {
  const {
    gates
  } = state;
  const isQA = env.isQa() || getIsQAProxy();
  const override = safeLocalStorage.getItem(`${gateKey}_OVERRIDE`);
  if (override === 'true' && isQA) {
    return true;
  }
  return gates === null || gates === void 0 ? void 0 : gates.includes(gateKey);
};
export const getIsUngatedForSeats = state => {
  const isUngatedByPublicFlagOrOverride = getIsUngated(state, {
    gateKey: SEATS_VERSIONS_FEATURE_FLAG
  });
  const urlParams = new URLSearchParams(window.location.search);
  const isUngatedByQueryParamOverride = urlParams.get('forceSeatsPricing') === 'true';
  const isUngatedOnPublic = isUngatedByPublicFlagOrOverride || isUngatedByQueryParamOverride;
  return isUngatedOnPublic || getIsUngated(state, {
    gateKey: SEATS_ACCESS
  });
};
export const getAreGatesPopulated = state => {
  return state.gates.length > 0;
};
export const getIsUngatedForMarketingPlus = state => {
  return hasAnyMarketingPlusSkuInProductData(state);
};
export const getIsUngatedForBreezeIntelligence = state => {
  return hasBreezeIntelligenceSkusInProductData(state);
};
export const getIsUngatedForCheckoutInterstitialUI = state => {
  return getIsUngated(state, {
    gateKey: CHECKOUT_INTERSTITIAL_UI_GATE
  });
};
export const getIsUngatedForRecommendedView = state => getIsUngated(state, {
  gateKey: RECOMMENDED_VIEW
});
export const getIsUngatedForFTSStagedUsers = state => getIsUngated(state, {
  gateKey: FTS_STAGED_USERS
});
export const getIsUngatedForHubSpotCredits = state => {
  var _urlParams$get;
  const isQA = env.isQa() || getIsQAProxy();
  const urlParams = new URLSearchParams(window.location.search);
  const forceLegacyBreeze = (_urlParams$get = urlParams.get('forceLegacyBreeze')) !== null && _urlParams$get !== void 0 ? _urlParams$get : safeLocalStorage.getItem('forceLegacyBreeze');
  const showLegacyBreeze = isQA && forceLegacyBreeze === 'true';
  /**
   * @temporary This should be removed once hubspot credits is live
   * @expiration 2025-06-09
   * @deprecated
   */
  if (showLegacyBreeze) return false;
  const hasHubSpotCredits = hasHubSpotCreditsSkuInProductData(state);
  if (!hasHubSpotCredits) return false;
  const isUngated = getIsUngated(state, {
    gateKey: HUBSPOT_CREDITS
  }) || getIsUngated(state, {
    gateKey: HUBSPOT_CREDITS_FLAG
  });
  return isUngated;
};
export const getIsUngatedForRemoveMerchCardSteppers = state => {
  return getIsUngated(state, {
    gateKey: REMOVE_MERCH_CARD_STEPPERS_GATE
  });
};
export const getIsUngatedForPurchaseMotionCTA = state => {
  return getIsUngated(state, {
    gateKey: PURCHASE_MOTION_CTA
  });
};